import React from 'react';
import './About.css';
import './App.css';
import aboutImage from './assets/about-image.png'; // Adjust the path as necessary

const About = () => {
  return (
    <div className="about-container" id="about" name='about'>
      <div className="about-inner">
        <div className="about-header">
          <span className="section-tag">OUR HERITAGE</span>
          <h2 className="section-title">A Legacy of Craftsmanship</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="about-grid">
          <div className="about-image-wrapper">
            <img src={aboutImage} alt="Founder working with leather" className="about-image" />
            <div className="image-caption">ESTABLISHED 1972</div>
          </div>
          
          <div className="about-text-content">
            <p className="lead-text">
              “If You Can Dream It, You Can Do It…”
            </p>
            
            <div className="story-columns">
              <p>
                Coming from a non-business oriented family, I stand here as the Proprietor of
                Flora Exports. My journey began in 1972, fueled by a strong aspiration to create 
                something independent and exceptional in the leather industry.
              </p>
              
              <p>
                Years of dedication and attachment to this trade led to a pivotal moment in 
                February 1996. I traveled to Germany with my first handmade samples. When Mr. Peter Arnold 
                saw them, he was impressed by the artistry—and the journey of Flora Exports truly began.
              </p>

              <p>
                Today, I continue this legacy alongside my son, constantly innovating while 
                maintaining the international standards our customers have trusted for decades. 
                Our thirst for knowledge and quality remains as intense as it was 50 years ago.
              </p>
            </div>
            
            <div className="founder-signoff">
              <span className="founder-name">The Proprietor</span>
              <span className="company-name">Flora Exports</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
